import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'cass-indeterminate-circular-progress-indicator',
	templateUrl: './indeterminate-circular-progress-indicator.component.html',
	styleUrls: ['./indeterminate-circular-progress-indicator.component.css']
})
export class IndeterminateCircularProgressIndicatorComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}
}
